import { useSharedProjectScopedActionHandlers } from "features/project-management/model/useSharedProjectScopedActionHandlers"
import { ProjectModel } from "features/project-management/types/ProjectModel"

import { useAggregatedSharedProjectData } from "../api/useAggregatedSharedProjectData"

export function useSharedProject(
  { projectShareID }: { projectShareID: string },
  options?: { includePrice?: boolean; includeAttachments?: boolean }
): ProjectModel {
  const { projectData } = useAggregatedSharedProjectData({
    projectShareID,
    options: {
      includePrice: options?.includePrice,
      includeAttachments: options?.includeAttachments
    }
  })
  const h = useSharedProjectScopedActionHandlers({
    projectID: projectData.project?.data?.id,
    projectShareID
  })

  return {
    core: {
      data: {
        project: projectData.project,
        permissions: projectData.permissions,
        role: projectData.role,
        phases: projectData.phases,
        meta: projectData.meta
      },
      handlers: {
        onOpen: undefined,
        onShowDetails: undefined,
        onEdit: undefined,
        onAddClarificationRequest: undefined,
        onDelete: undefined,
        onActivate: undefined,
        onShare: h.onShare,
        onExport: h.onExport,
        onGaebExport: h.onGaebExport,
        onMusterheftExport: h.onMusterheftExport,
        onDuplicate: h.onDuplicate,
        onOpenProjectHistory: undefined
      }
    },
    team: {
      data: {
        team: projectData.team
      },
      handlers: {
        onManageTeam: undefined,
        onInviteMember: undefined,
        onLeaveTeam: undefined
      }
    },
    pricing: {
      data: {
        price: projectData.price,
        priceLists: projectData.priceLists,
        standardInflationSurcharge: projectData.standardInflationSurcharge
      }
    },
    attachments: {
      data: {
        attachments: projectData.attachments,
        attachmentCategories: projectData.attachmentCategories
      },
      handlers: {
        onOpenAttachments: h.onOpenAttachments
      }
    },
    creation: null,
    clarificationRequest: null
  }
}
